import React, { useContext } from "react";
import { AuthContext } from "../contexts/AuthContext";
import { AdminContext } from "../contexts/AdminContext";
import { Navigate, Outlet, useLocation } from 'react-router-dom'

export const SuperAdminRoutes = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { admin } = useContext(AdminContext)
  const { pathname } = useLocation()

  return (
    !isAuthenticated ? 
      <Navigate to={`/signin?redirect=${pathname}`} /> :
      isAuthenticated && admin.role === 'super' ? 
      <Outlet /> :
      <Navigate to='/dashboard' />
  )
};